import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import VeilederSlettingAvRenterDto from '../Models/VeilederSlettingAvRenterDto';
import { VeilederSlettingAvRenterAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import { SlettingAvRenterSatser } from '../Utilities/SlettingAvRenterSatserApi';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultatOwnProps {
    satser: SlettingAvRenterSatser | null,
    valg: ValgTypes.ValgState,
    valuta: string,
    eventId: string | null,
}

type ResultatDisplayProps = ResultatOwnProps & MapStateToProps;

function ResultatCaComponent(props: ResultatDisplayProps): JSX.Element {
    const { epiContext, eventId } = props;
    const [visCaModal, setVisCaModal] = useState(false);
    const [visVilkarAModal, setVisVilkarAModal] = useState(false);

    function fokusOverskrift(): void {
        let overskrift = document.getElementById("js-resultat-ca-component-overskrift");
        if(overskrift !== null) {
            overskrift.focus(); 
            overskrift.scrollIntoView();
        }
    }

    useEffect(() => {
        fokusOverskrift();
        updateLiveMessage();
    }, []);

    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }

    function onModalCaClick(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();
        setVisCaModal(true);
    }

    function onRequestLukkModalCa(): void {
        setVisCaModal(false);
    }

    return (
            <div className="c-veileder__panel c-veileder__panel-paddingBottom-killer c-veileder__panel--lilac">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h3 id="js-resultat-ca-component-overskrift" className="c-veileder--overskrift c-veileder--overskrift-stor">
                            {contentResolver(epiContext, 'overskriftCa')}
                        </h3>
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'tekstCa')}
                        </div>
                    </div>
                    <div className="c-veileder__content c-veileder__content--indented">
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-stor">
                            {contentResolver(epiContext, 'overskrift2Ca')}
                        </h4>
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'tekst2Ca')}
                        </div>
                        <div className="c-veileder--kontainer">
                            <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onModalCaClick}>
                                {contentResolver(epiContext, "modalCaLenketekst")}
                            </button>
                            <ModalCompontent
                                isOpen={visCaModal}
                                onRequestClose={onRequestLukkModalCa}
                                ariaCloseText={resolveRawText(epiContext, "modalCaVilkarAriaLabel")}
                                eventId={eventId}
                            >
                                <ArticleContentComponent
                                    headerinnhold={contentResolver(epiContext, "modalCaVilkarTittel")}
                                    contentinnhold={contentResolver(epiContext, "modalCaVilkarContent")}
                                />
                            </ModalCompontent>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row c-veileder__panel---secondary-lilac">
                    <div className="c-veileder__content">
                        <h4 className="c-veileder--overskrift c-veileder--overskrift-mellom">
                            {contentResolver(epiContext, 'overskrift3Ca')}
                        </h4>
                    </div>
                </div>
                <div className="c-veileder__panel-row c-veileder__panel---secondary c-veileder__panel---secondary-lilac">
                    <div className="c-veileder__content">
                        <div className="c-veileder--tekstomraade">
                            {contentResolver(epiContext, 'tekst3Ca')}
                        </div>
                    </div>
                    <div className="c-veileder__content c-veileder__content--indented">
                        <div className="c-veileder--tekstomraade">
                            <h5 className="c-veileder--overskrift-litt-margin">{contentResolver(epiContext, 'mellomOverskrift1Ca')}</h5>
                            <div className="c-veileder__tekst">{contentResolver(epiContext, 'mellomTekst1Ca')}</div>
                        </div>
                        <div className="c-veileder--tekstomraade">
                            <h5 className="c-veileder--overskrift-litt-margin">{contentResolver(epiContext, 'mellomOverskrift2Ca')}</h5>
                            <div className="c-veileder__tekst">{contentResolver(epiContext, 'mellomTekst2Ca')}</div>
                        </div>
                        <div className="c-veileder--tekstomraade">
                            <h5 className="c-veileder--overskrift-litt-margin">{contentResolver(epiContext, 'mellomOverskrift3Ca')}</h5>
                            <div className="c-veileder__tekst">{contentResolver(epiContext, 'mellomTekst3Ca')}</div>
                        </div>
                        <div>
                            <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarAClick}>
                                {contentResolver(epiContext, "modalLenketekst")}
                            </button>
                            <ModalCompontent
                                isOpen={visVilkarAModal}
                                onRequestClose={onRequestLukkVilkarA}
                                ariaCloseText={resolveRawText(epiContext, "modalVilkarAriaLabel")}
                                eventId={eventId}
                            >
                                <ArticleContentComponent
                                    headerinnhold={contentResolver(epiContext, "modalVilkarTittel")}
                                    contentinnhold={contentResolver(epiContext, "modalVilkarContent")}
                                />
                            </ModalCompontent>
                        </div>
                    </div>
                </div>
            </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
}

export default connect(
    (state: VeilederSlettingAvRenterAppState, ownProps: ResultatOwnProps): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            resultat: state.resultat,
        };
    }
)(ResultatCaComponent);